import { inject, shallowRef, type InjectionKey, type Ref } from 'vue';
import type { ConnectSettingsScope } from './scope';

export interface ConnectSettingsScopes {
  scopes: Readonly<Ref<readonly ConnectSettingsScope[]>>;
  load(): Promise<void>;
}

/** A host supplies the same authorised layers its central settings page offers. */
export const connectSettingsScopesKey: InjectionKey<() => ConnectSettingsScopes> = Symbol('connect.settings.scopes');

export function useConnectSettingsScopes(): ConnectSettingsScopes {
  const create = inject(connectSettingsScopesKey, undefined);
  return create?.() ?? { scopes: shallowRef([]), load: async () => {} };
}
